module.exports = __webpack_public_path__ + "static/media/decibel-tl.53c01a77.md";